// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductsWrapper_wrapper___Qfyj","title":"ProductsWrapper_title__gMNIV"};